'use strict';
define([
    'angular',
    'modules/settings/customizations/customizations.controller'
],function(angular, CustomizationsController){
    var app = angular.module('settings.customizations', []);
    app.controller('CustomizationsController', CustomizationsController);
    return app;
});